import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { computed, defineComponent, reactive, ref } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { Loading } from "@element-plus/icons";
import Head from "@/components/Head/index.vue";
import { useRouter } from "vue-router";
import { ArrowRight } from "@element-plus/icons";
export default defineComponent({
  name: "",
  components: {
    Head: Head,
    Loading: Loading,
    ArrowRight: ArrowRight
  },
  setup: function setup() {
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var loading = ref(false);
    var PaginationInit = ref(false); // 数据列表信息

    var dataList = reactive({
      listData: [],
      imgList: [require("../../assets/img/rank/guan1.png"), require("../../assets/img/rank/guan3.png"), require("../../assets/img/rank/guan2.png")],
      changeState: 'getperiodRank',
      flag: true,
      myList: {},
      myListId: -1
    });
    getTabledata();

    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } //切换


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, person;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[dataList.changeState]();

              case 2:
                res = _context.sent;
                dataList.listData = res.data;
                person = sessionStorage.getItem("user");
                res.data.forEach(function (item, index) {
                  if (item.userId == JSON.parse(person).userId) {
                    dataList.myList = item;
                    dataList.myListId = index + 1;
                  }
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTabledata.apply(this, arguments);
    }

    function tabChange(val) {
      if (val == 0) {
        dataList.flag = true;
        dataList.changeState = 'getperiodRank';
      } else {
        dataList.flag = false;
        dataList.changeState = 'getcreditRank';
      }

      getTabledata();
    } // 返回


    function back() {
      router.back();
    } //计算分数


    var score = computed(function () {
      return function (val) {
        if (val) {
          return val;
        } else {
          return '暂无';
        }
      };
    });
    return {
      loading: loading,
      PaginationInit: PaginationInit,
      dataList: dataList,
      tabChange: tabChange,
      back: back,
      score: score
    };
  }
});